import { addValueToLinkState } from "seneca-common/utils/routing";

import { MiniMockSessionData } from "features/classroom/pages/exam-questions/pages/mini-mock-pages/analytics/useMiniMockAnalytics";
import { EQAnswerWithQuestion } from "features/teachers/types";
import { ROUTES } from "routing/routes";

export function linkToCourseExamQuestionsMiniMockMarking(courseId?: string) {
  return `${courseId ? ROUTES.CLASSROOM.COURSE.EXAM_QUESTIONS.MINI_MOCK.buildPath({ courseId }) : ROUTES.CLASSROOM.COURSE.EXAM_QUESTIONS.MINI_MOCK.path}/marking`;
}

export const makeLinkToCourseMiniMockMarkingWithState = ({
  miniMockAnswers,
  miniMockSessionData
}: {
  miniMockAnswers: EQAnswerWithQuestion[];
  miniMockSessionData: MiniMockSessionData;
}) => {
  return addValueToLinkState(
    linkToCourseExamQuestionsMiniMockMarking(miniMockSessionData.courseId),
    {
      miniMockAnswers,
      miniMockSessionData
    }
  );
};
